import React from "react";
import { useTranslation } from "react-i18next";

export function EnableGoogleReserveIntegration() {
  const { t } = useTranslation("common");
  return (
    <div className="flex flex-col gap-6">
      <p>{t("Integrations.GoogleReserve.description")}</p>
      <div className="flex flex-col gap-2">
        <strong>{t("Step_x", { x: 1 })}</strong>
        <p>{t("Integrations.GoogleReserve.step_1_description")}</p>
      </div>
      <div className="flex flex-col gap-2">
        <strong>Step 2</strong>
        <p>
          Select your listing by typing the company name in the form below. Make
          sure the information displayed matches your company's.
        </p>
      </div>
    </div>
  );
}

export function DisableGoogleReserveIntegration() {
  const { t } = useTranslation("common");
  return (
    <div className="flex flex-col gap-6">
      <p>{t("Integrations.GoogleReserve.disable_description")}</p>
    </div>
  );
}
